export default {
	small: 600,
	medium: 800,
	large: 1000,
	xlarge: 1200
}
